import { Link } from "react-router-dom";

interface SectionHeadingProps {
  icon?: string;
  title: string;
  subtitle?: string;
  moreLink?: string;
  moreText?: string;
}

export default function SectionHeading({ icon, title, subtitle, moreLink, moreText = "查看全部" }: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6">
      <div>
        <h2 className="flex items-center gap-2 text-lg md:text-2xl font-bold text-foreground-950">
          {icon && (
            <span className="w-7 h-7 md:w-8 md:h-8 rounded-lg bg-accent-100 text-accent-700 flex items-center justify-center shrink-0">
              <i className={`${icon} text-base md:text-lg`} />
            </span>
          )}
          {title}
        </h2>
        {subtitle && <p className="mt-1.5 text-sm text-foreground-500">{subtitle}</p>}
      </div>
      {moreLink && (
        <Link
          to={moreLink}
          className="shrink-0 flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer"
        >
          {moreText}
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-s-line text-lg" />
          </span>
        </Link>
      )}
    </div>
  );
}